module.exports = __webpack_public_path__ + "img/computer9.bc42af17.gif";